<ng-container *ngIf="notifyConnection$ | async"></ng-container>
<ng-container *ngIf="markAsRead$ | async"></ng-container>

<mat-toolbar class="p-0 mat-elevation-z1">
  <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">
    <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
      <button
        mat-icon-button
        class="navbar-toggle-button"
        *ngIf="!hiddenNavbar && !rightNavbar"
        (click)="toggleSidebarOpen('navbar')"
        fxHide.gt-md>
        <mat-icon class="secondary-text">menu</mat-icon>
      </button>

      <div class="toolbar-separator" *ngIf="!hiddenNavbar && !rightNavbar" fxHide.gt-md></div>

      <div fxLayout="row" fxLayoutAlign="start center" *ngIf="horizontalNavbar">
        <div class="logo ml-4">
          <img class="logo-icon" src="./assets/images/logos/fuse.svg" />
        </div>
      </div>

      <div class="px-2 md:px-1 flex flex-row items-center">
        <ng-container *ngFor="let item of getShortcuts(); trackBy: trackFnByShortcut">
          <a mat-icon-button [routerLink]="item.url">
            <mat-icon class="secondary-text">{{ item.icon }}</mat-icon>
          </a>
        </ng-container>

        <ng-container *ngIf="isMobile && cuttingSettings$ | async as settings">
          <a mat-icon-button [routerLink]="settings.howToOrderUrl" target="_blank">
            <mat-icon class="secondary-text">help</mat-icon>
          </a>
        </ng-container>
      </div>
    </div>

    <div fxFlex="1 0 auto" *ngIf="!isMobile && cuttingSettings$ | async as settings">
      <a mat-button [href]="settings.howToOrderUrl" target="_blank">
        <div fxLayout="row" fxLayoutAlign="center center">
          <mat-icon class="secondary-text">help</mat-icon>
          <span class="h2 secondary-text" i18n>Как сделать заказ</span>
        </div>
      </a>
    </div>

    <div class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">
      <button mat-button [matMenuTriggerFor]="userMenu" class="user-button">
        <div fxLayout="row" fxLayoutAlign="center center">
          <img class="avatar mr-0 sm:mr-1" src="./assets/images/avatars/profile.svg" />
          <span class="username mr-3" fxHide fxShow.gt-sm>{{ client?.personShortName || client?.companyName }}</span>
          <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
        </div>
      </button>

      <mat-menu #userMenu="matMenu" [overlapTrigger]="false">
        <button mat-menu-item [routerLink]="['/profile']">
          <mat-icon>account_circle</mat-icon>
          <span i18n>Профиль</span>
        </button>

        <button mat-menu-item class="" (click)="logout()">
          <mat-icon>exit_to_app</mat-icon>
          <span i18n>Выйти</span>
        </button>
      </mat-menu>

      <div class="toolbar-separator"></div>

      <button mat-button fxHide fxShow.gt-xs class="language-button" [matMenuTriggerFor]="languageMenu">
        <div fxLayout="row" fxLayoutAlign="center center">
          <img
            class="flag mr-2 w-4 outline outline-1 outline-gray-300"
            [src]="'./assets/images/flags/' + locale + '.svg'" />
          <span class="iso text-uppercase">{{ locale }}</span>
        </div>
      </button>

      <mat-menu #languageMenu="matMenu" [overlapTrigger]="false">
        <button
          mat-menu-item
          *ngFor="let lang of languages"
          [routerLink]="['/' + lang.id + '/#' + getCurrentRoute()]"
          (click)="changeLanguage(lang.id)">
          <span fxLayout="row" fxLayoutAlign="start center">
            <img
              class="flag mr-4 w-4 outline outline-1 outline-gray-300"
              [src]="'./assets/images/flags/' + lang.id + '.svg'" />
            <span class="iso">{{ lang.title }}</span>
          </span>
        </button>
      </mat-menu>

      <div class="toolbar-separator" fxHide fxShow.gt-xs></div>

      <button
        mat-icon-button
        (click)="toggleSidebarOpen('quickPanel')"
        class="quick-panel-toggle-button"
        aria-label="Toggle quick panel">
        <csl-animate-icon
          [animationMetadata]="getSwingMetadata()"
          [interval]="animInterval"
          [animStop]="animeteStop"
          [matBadge]="notificationsCount"
          [matBadgeHidden]="!notificationsCount"
          matBadgeSize="small"
          matBadgeColor="warn"
          class="secondary-text mat-icon">
          {{ notificationsCount ? 'notifications_active' : 'notifications' }}</csl-animate-icon
        >
      </button>

      <div class="toolbar-separator" *ngIf="!hiddenNavbar && rightNavbar" fxHide fxShow.gt-xs></div>

      <button
        mat-icon-button
        class="navbar-toggle-button"
        *ngIf="!hiddenNavbar && rightNavbar"
        (click)="toggleSidebarOpen('navbar')"
        fxHide.gt-md>
        <mat-icon class="secondary-text">menu</mat-icon>
      </button>
    </div>
  </div>
</mat-toolbar>
